import UserInfo from "../../interfaces/UserInfo";
import type { Conversation } from "../../services/chatService/ChatService";

export const isAutomatedBotConversation = (
    conversation: Conversation,
    currentUserId?: string | null,
): boolean => {
    if (conversation.isChannel || conversation.channel) return false;
    if (conversation.isBotDirect) return true;

    const participants = conversation.participants ?? [];
    if (participants.some(participant => participant.id?.startsWith("bot:"))) return true;

    const lastMessage = conversation.lastMessage as any;
    const lastAuthorId = lastMessage?.author?.id ?? lastMessage?.userId;
    if (lastMessage?.isBot || lastMessage?.botId || lastAuthorId?.startsWith?.("bot:")) return true;

    // Bot DMs are the only non-channel conversations stored with one human
    // participant. This supports payloads created before isBotDirect was exposed.
    return participants.length === 1 &&
        (!currentUserId || participants[0]?.id === currentUserId);
};

export const formatConversationTitle = (participants: UserInfo[]): string => {
    if (!participants || participants.length === 0) {
        return "Unknown conversation";
    }

    const nameList = participants.map(p => {
        const firstName = p.firstName || p.displayName || "Unknown";
        const lastNameInitial = p.lastName ? ` ${p.lastName.charAt(0)}.` : "";
        return `${firstName}${lastNameInitial}`;
    });

    if (nameList.length > 2) {
        return `${nameList.slice(0, 2).join(', ')} and ${nameList.length - 2} others`;
    }

    return nameList.join(' & ');
};
